/* repo/card*/
import {
  fetch as fetchApi,
  insert as insertApi,
  isString,
} from "./api";
import { CardTypeCodec, CardType, Data } from "../store/cardType/types";
import { withDecoded, flattenData } from "./";

function mapToModel(data: object): CardType {
  return withDecoded(CardTypeCodec, data, (decoded) => ({
    ...decoded,
  }));
}

function mapToChageset(processor: Data): Data {
  return processor;
}

export async function fetch(id: string | null, params?: {}): Promise<CardType> {
  return fetchApi({
    nestedResourcePath: ["cardType"],
    id: id
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

export async function save(cardType: Data): Promise<CardType> {
  console.log({
    cardType
  })
  return insertApi({
    nestedResourcePath: ["cardType"],
    id: cardType.id,
    data: mapToChageset(cardType),
  }).then((response) =>
    mapToModel(
      flattenData(
        isString(response.data) ? JSON.parse(response.data) : response.data
      )
    )
  );
}

